import React, { useState, useEffect, useContext } from "react";
import { Avatar, Box, Grid, Typography } from "@mui/material";
import TimeLineInfo from "./timeline-info";
import TicketFiles from "./ticket-files";
import {
  getAvatarColor,
  TICKET_STAGES,
  USER_ROLES,
} from "../../../utils/constants";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { Icon } from "@iconify/react";
import moment from "moment";
import AppContext from "../../../utils/context";
const TicketAttachments = ({
  ticketDetails,
  openForm,
  loadData,
  timeline,
  setViewComplaint,
}) => {
  const [showAllComments, setShowAllComments] = useState(false);
  const [commentTimeline, setCommentTimeline] = useState([]);
  const handleShowAllComments = () => {
    setShowAllComments(true);
  };
  const { userDetails } = useContext(AppContext);
  const getCommentList = () => {
    let url = `${HOSTNAME}${REST_URLS.COMMENT}/${ticketDetails.id}`;
    if (userDetails.role === USER_ROLES.OEM) {
      url = `${HOSTNAME}${REST_URLS.OEM_COMMENT}/${ticketDetails.id}`;
    }
    invokeApi(HTTP_METHODS.GET, url, null, {
      timelineflag: true,
    })
      .then((res) => {
        if (!res.message) {
          setCommentTimeline(res);
        }
      })
      .catch((err) => console.error(err));
  };
  const commentsToShow = showAllComments
    ? commentTimeline
    : commentTimeline.slice(0, 3); // Show only the first two comments

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    getCommentList();
  }, []);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={6} className="page-load">
          <div
            className="form-con hide-scrollbar"
            style={{ maxHeight: "80vh" }}
          >
            <p className="form-header">Attachments</p>
            <TicketFiles
              timeline={timeline}
              ticketDetails={ticketDetails}
              loadData={loadData}
            />
          </div>
        </Grid>
        <Grid item md={6} xs={12} className="page-load">
          <div
            className="form-con hide-scrollbar"
            style={{ maxHeight: "70vh" }}
          >
            <p className="form-header">Comments</p>
            <div className="gray-bg-con">
              <Icon
                icon="iconamoon:comment-dots-duotone"
                width="2rem"
                height="2rem"
                style={{ color: "#001a53", marginRight: "15px" }}
              />
              <p>Comments</p>
            </div>

            {commentsToShow.length > 0 ? (
              commentsToShow?.map((line, index) => {
                const name = line?.createdBy?.name;
                return (
                  <div key={index}>
                    <div className="comment-con">
                      <Avatar
                        sx={{
                          bgcolor: getAvatarColor(name?.[0]),
                          marginRight: 2,
                        }}
                        title={name}
                      >
                        <Box sx={{ marginTop: "1px", marginLeft: "1px" }}>
                          {name?.[0]?.toUpperCase()}
                        </Box>
                      </Avatar>
                      <div>
                        <p className="primary-text">{line.comment}</p>
                        <p style={{ color: "#1B1F26B8", marginTop: "5px" }}>
                          added on {moment(line.createdAt).format("DD/MM/YYYY")}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 5,
                  mb: 10,
                }}
              >
                No Comments
              </Typography>
            )}

            {commentTimeline.length > 3 && !showAllComments && (
              <div onClick={handleShowAllComments} className=" load-more-btn">
                Load More
              </div>
            )}
          </div>
        </Grid>
      </Grid>
      {userDetails.role !== USER_ROLES.OEM && (
        <Grid container className="page-load">
          <Grid item md={12}>
            <TimeLineInfo
              ticketDetails={ticketDetails}
              timeline={timeline}
              openForm={() => setViewComplaint(true)}
              onDateChange={loadData}
              loadData={loadData}
            />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default TicketAttachments;
